import 'reflect-metadata'
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import User from '../../models/User.model';

export interface AppState {
  user?: User|null
}

const initialState: AppState = {
  
}

const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setSignOut: state => {
      state.user = null;
    },
    // setToken: (state, action: PayloadAction<string|null>) => {
    //   state.token = action.payload;
    //   initToken(action.payload);
    // },
    setUser: (state, action: PayloadAction<User|null>) => {
      state.user = action.payload;
    },
  }
})

export const { 
  setSignOut,
  setUser
} = slice.actions;
export default slice.reducer;